import { FC } from 'react';
import {
  FormPacketSelectorComponents,
  FormPacketSelectorHooks,
  FormPacketSelectorTypes,
} from '@frontend/form-packet-selector';
import { useSendFormsStore } from '../../../providers';
import { containerStyle, formPacketListContainerStyle } from './select-document.styles';

const SelectDocumentStep: FC = () => {
  const { setFormOrPacketToSend, locationId } = useSendFormsStore(['setFormOrPacketToSend', 'locationId']);
  const { selectorProps } = FormPacketSelectorHooks.useFormPacketSelector({
    groupId: locationId,
    onSelect: (item, type) => {
      switch (type) {
        case FormPacketSelectorTypes.Category.FORMS: {
          const { id, reviewRequired, name, formPmsId } = item as FormPacketSelectorTypes.FormV2;
          setFormOrPacketToSend({
            id: id ?? '',
            type: FormPacketSelectorTypes.Category.FORMS,
            reviewRequired: reviewRequired ?? false,
            name: name ?? '',
            isNonEditable: !!formPmsId,
          });
          break;
        }

        case FormPacketSelectorTypes.Category.PACKETS: {
          const { id, reviewRequired, name, forms = [] } = item as FormPacketSelectorTypes.PacketV2;
          const formIds: string[] = [];

          for (const form of forms) {
            if (form.id) {
              formIds.push(form.id);
            }
          }

          setFormOrPacketToSend({
            id: id ?? '',
            type: FormPacketSelectorTypes.Category.PACKETS,
            reviewRequired: reviewRequired ?? false,
            name: name ?? '',
            isNonEditable: false,
            formIds,
          });
          break;
        }
      }
    },
  });

  return (
    <div css={containerStyle}>
      <FormPacketSelectorComponents.FormPacketFilters {...selectorProps.formPacketFiltersProps} />
      <div css={formPacketListContainerStyle}>
        <FormPacketSelectorComponents.FormPacketList {...selectorProps.formPacketListProps} />
      </div>
    </div>
  );
};

export default SelectDocumentStep;
